/**
 * Standard shadcn `cn` helper — combines clsx (conditional class joining)
 * with tailwind-merge (last-write-wins resolution of conflicting Tailwind
 * utilities). Used by every shadcn primitive in components/ui.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
